import {LOGIN, LOGOUT, UPDATE_BALANCE, SYNCCOOKIES} from '../actions/auth';

import Cookies from 'js-cookie';

const initialState = {
    loggedIn: null,
    user:  null,
    token: null
};

const auth = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN:
            const {user, token, referral_settings} = action.data;

            return {
                ...state,
                user: {...user, referral_settings},
                token,
                loggedIn: true
            }
        case LOGOUT:
            return {
                ...state,
                user: null,
                token: null,
                loggedIn: false
            }
        case SYNCCOOKIES:
            const {user: userData, token: userToken, loggedIn} = action.data;
            return {
                ...state,
                user: userData,
                token: userToken,
                loggedIn
            }
        case UPDATE_BALANCE:
            const userCopy = {...JSON.parse(state.user)};
            userCopy.unused_balance = action.balance;
            Cookies.set('user', typeof userCopy === 'string' ? userCopy : JSON.stringify(userCopy))

            return {
                ...state,
                user: userCopy
            }
        default:
            return state;
    }
};

export default auth;
